import {
  TASK_JOB_TYPE,
  type DeliveryJob,
  type PickupJob,
  type Task,
  type TimeSlot,
} from '@klareospace/pharos-lib-types';

/** Minimal shape needed to locate a task's jobs — accepts partial task shapes. */
type TaskWithJobs = Pick<Task, 'jobs'>;

/** Finds the delivery job by type, never by array index — job order on `Task.jobs` is not guaranteed. */
export function findDeliveryJob(task: TaskWithJobs): DeliveryJob | undefined {
  return task.jobs.find((job): job is DeliveryJob => job.type === TASK_JOB_TYPE.DELIVERY);
}

/** Finds the pickup job by type, never by array index — job order on `Task.jobs` is not guaranteed. */
export function findPickupJob(task: TaskWithJobs): PickupJob | undefined {
  return task.jobs.find((job): job is PickupJob => job.type === TASK_JOB_TYPE.PICKUP);
}

/**
 * The product-canonical task timeslot: the delivery job's `data.timeSlot`, `undefined` when there
 * is no delivery job or it has no slot. This is the same definition the backend task list uses to
 * sort and filter tasks, regardless of pickup/delivery job order.
 */
export function resolveTaskTimeSlot(task: TaskWithJobs): TimeSlot | undefined {
  return findDeliveryJob(task)?.data.timeSlot;
}
